import { Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'sag-ui-tab-content',
  template: `<div
    [ngClass]="{ 'animate-slideLeft': slide, 'animate-slideRight': !slide }"
  >
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </div>`,
})
export class TabContentComponent {
  @Input({ required: true }) template: TemplateRef<any>;
  @Input({ required: true }) slide: boolean;
}
